export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account of the Offeror"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offeror’s Account"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}